// extracted by mini-css-extract-plugin
export default {"navigation-bar":"navbar_component_navigation-bar__zGXE1","logo":"navbar_component_logo__fAyi8"};